/**
 * Token management utilities for localStorage
 */

const TOKEN_KEY = 'sb-access-token';

/**
 * Retrieves the stored access token from localStorage.
 *
 * @returns The stored token string, or null if not found or not in browser environment
 */
export function getStoredToken(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(TOKEN_KEY);
}

/**
 * Stores an access token in localStorage.
 *
 * @param token - The access token to store
 */
export function setStoredToken(token: string): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(TOKEN_KEY, token);
  }
}

/**
 * Removes the stored access token from localStorage.
 */
export function removeStoredToken(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(TOKEN_KEY);
  }
}
